<template>
    <div class="">
        <div class="d-flex align-items-center justify-content-between">
            <div>
                <ol class="breadcrumb fs-sm mb-1">
                    <li class="breadcrumb-item"><router-link to="/dashboard">Dashboard</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">Reminders</li>
                </ol>
                <label class="form-label"> <h4>Reminders</h4></label>
            </div>
            <div class="d-flex">
                <button class="btn d-flex align-item-center btn-success me-1" @click="downloadExcel"><i class="ri-download-line me-1"></i>Download Reminders</button>
                <router-link to="/dashboard" v-if="fromDashboard" class="btn d-flex align-item-center btn-primary "><i class="ri-list-check me-1"></i>Dashboard</router-link>

            </div>
        </div>
        <div class="row">

            <div class="col-xl-12" >
                <div class="card br-16 card-shadow" >
                    <div class="card-body">
                          <div class="row mb-3">

                    <div class="col">
                        <Search
                            :class="{ 'is-invalid': errors?.user_id }"
                            :customClass="{ 'is-invalid': errors?.user_id }"
                            :initialize="meta.user_id"
                            id="user_id"
                            label="name"
                            placeholder="Select User"
                            :data=" users"
                            @input=" user => meta.user_id = user"
                        >
                        </Search>
                    </div>
                    <div class="col">
                        <flatPickr class="form-control" placeholder="Select Date Range"
                            :class="{ 'is-invalid': errors?.date_time }" ref="flatpickr"
                            :config="config" @onChange="getSelectedDates" style="width: 100%;">
                        </flatPickr>
                        <span v-if="errors.reminder_date_time" class="invalid-feedback">{{ errors.reminder_date_time}}</span>
                    </div>
                    <div class="col mt-auto">
                        <button type="button" @click="index" class="btn btn-primary me-2">Search</button>
                        <button type="button" @click="reset_search" class="btn btn-danger">Reset</button>
                    </div>
                </div>
                        <!-- <nav class="nav nav-classic">
                            <span class="nav-link text-dark"><span>User</span> <span class="badge text-dark" style="text-wrap: balance;">{{ session_comment.User.name}}</span></span>
                            <span class="nav-link text-dark"><span>Stage</span> <span class="badge text-dark" style="text-wrap: balance;">{{ session_comment.Stage.stage}}</span></span>
                            <span class="nav-link text-dark"><span>Comment</span> <span class="badge text-dark" style="text-wrap: balance;">{{ session_comment.comment}}</span></span>
                        </nav> -->

                        <div class="table-responsive table-responsive-sm" style="height:340px; overflow: scroll;">
                            <table class="table table-sm text-nowrap table-bordered mb-0">
                                <thead>
                                    <tr v-if="session_comments.length == 0">
                                        <th class="text-center">#</th>
                                        <th >User</th>
                                        <th>School</th>
                                        <th>KG Strength</th>
                                        <th>Place</th>
                                        <th>Pincode</th>
                                        <th>Address</th>
                                        <th>Next Reminder Date</th>
                                        <th class="text-center">Present Stage</th>
                                        <th class="text-center">Next Stage</th>
                                        <th>Status</th>
                                        <th>Remark</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                    <tr v-else>
                                        <th class="text-center sticky-col col-0 sticky">#</th>
                                        <th class="sticky-col col-1 sticky" @click="sort('user_name')">User</th>
                                        <th class="sticky-col col-2 sticky">School</th>
                                        <th class="sticky-col col-3 sticky">KG Strength</th>
                                        <th>Place</th>
                                        <th>Pincode</th>
                                        <th>Address</th>
                                        <!-- <th>District</th> -->
                                        <th>Next Reminder Date</th>
                                        <th class="text-center">Present Stage</th>
                                        <th class="text-center">Next Stage</th>
                                        <th>Status</th>
                                        <th>Remark</th>
                                        <th class="text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="session_comments.length == 0">
                                        <td colspan="13" class="text-center">No records found</td>
                                    </tr>
                                    <tr v-for="(session_comment, key) in session_comments" :key="key">
                                        <td class="text-center sticky-col col-0 sticky">{{ meta.from + key }}</td>
                                        <td class="sticky-col col-1 sticky">{{session_comment?.User?.name}}</td>
                                        <td class="sticky-col col-2 sticky text-wrap">{{session_comment?.School?.school_name}}</td>
                                        <td class="sticky-col col-3 sticky">
                                            <span v-for="fields, key in session_comment?.School?.SessionFields || []" :key="key">
                                                <span v-if="fields?.field_name == 'KG Strength'">{{ fields?.value }} </span>
                                            </span>
                                        </td>
                                        <td>{{ session_comment?.School?.place }}</td>
                                        <td>{{ session_comment?.School?.pincode }}</td>
                                        <td>{{ session_comment?.School?.address }}</td>
                                        <!-- <td>{{ session_comment.School.District.district }}</td>                                         -->
                                        <td>{{ changeDateTime(session_comment.reminder_date_time)}}</td>
                                        <td class="text-center">{{ session_comment?.PresentStage?.stage }}</td>
                                        <td class="text-center">{{ session_comment?.NextStage?.stage }}</td>
                                        <td>{{ session_comment?.status ? 'Completed' : 'Pending' }}</td>
                                        <td>{{ session_comment?.remarks }}</td>
                                        <td class="text-center text-nowrap">
                                            <a
                                                v-if="isAdmin"
                                                @click.prevent="openEditReminderDate(session_comment)"
                                                data-bs-toggle="modal"
                                                data-bs-target="#editReminderDate"
                                                href="javascript:void(0)"
                                                class="text-primary me-2"
                                                title="Edit visiting date"
                                            ><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                            <a
                                                @click.prevent="viewComment(session_comment)"
                                                data-bs-toggle="modal"
                                                data-bs-target="#viewComment"
                                                href="javascript:void(0)"
                                                class="text-success"
                                                title="View comment"
                                            ><i class="ri-eye-line fs-18 lh-1"></i></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                <div class="mt-3">
                         <div class="d-flex justify-content-between align-items-center">
                            <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                <option>10</option>
                                <option>15</option>
                                <option>20</option>
                                <option>25</option>
                                <option>30</option>
                            </select>
                            <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta?.totalRows }} entries</span>
                            <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                        </div>
                    </div>
            </div>
            <div class="modal fade" id="viewComment" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Comment</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <h6>{{ session_comment }}</h6>
                    </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="editReminderDate" tabindex="-1" aria-labelledby="editReminderDateLabel" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="editReminderDateLabel">Edit Visiting Date</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <p class="mb-2" v-if="editReminder?.School?.school_name">
                                <strong>{{ editReminder.School.school_name }}</strong>
                            </p>
                            <p class="mb-3 text-muted" v-if="editReminder?.User?.name">
                                User: {{ editReminder.User.name }}
                            </p>
                            <label class="form-label">Next Visiting Date</label>
                            <flatPickr
                                class="form-control"
                                placeholder="Select Next Visiting Date and Time"
                                :class="{ 'is-invalid': editReminderErrors.reminder_date_time }"
                                v-model="editReminderDateTime"
                                :config="editReminderDateConfig"
                            />
                            <span v-if="editReminderErrors.reminder_date_time" class="invalid-feedback d-block">
                                {{ editReminderErrors.reminder_date_time }}
                            </span>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary" @click="submitReminderDate">Update</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import Search from "@/components/Search.vue";
    // import moment from "moment";
    import moment from 'moment-timezone';
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import axios from 'axios';
    export default {
        components: { Pagination, Search, flatPickr },
        data() {
            return {
                meta: {
                    search: "",
                    order_by: "asc",
                    keyword: "session_form_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    user_id: "",
                    // reminder_date_time: moment().format("DD-MM-YYYY"),
                    reminder_date_time:"",
                    from_date_time: moment().format("DD-MM-YYYY"),
                    to_date_time: moment().add(1, 'days').format("DD-MM-YYYY"),
                },
                from_date_time: moment().format("DD-MM-YYYY"),
                to_date_time: moment().add(1, 'days').format("DD-MM-YYYY"),
                session_comments: [],
                users: [],
                errors: [],
                session_comment:'',
                editReminder: null,
                editReminderDateTime: '',
                editReminderErrors: {},
                editReminderDateConfig: {
                    enableTime: true,
                    dateFormat: 'd-m-Y H:i',
                    allowInput: true,
                    static: true,
                    minDate: 'today',
                    minTime: '09:30',
                    maxTime: '18:30',
                },
                config: {
                    mode:'range',
                    defaultDate: [moment().format("DD-MM-YYYY"), moment().add(1, 'days').format("DD-MM-YYYY")],
                    dateFormat: 'd-m-Y',
                }
            };
        },
        mounted() {
            this.getUsers();
    },
        computed: {
            fromDashboard() {
        const from = this.$route.query.from;
        return from === 'dashboard';
        },
            isAdmin() {
                return this.$store.getters.user?.role === 'Admin';
            },
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                console.log('vm.$store.getters.report_search:-----', vm.$store.getters.reminder_search)
                vm.meta.user_id = vm.$store.getters.reminder_search?.user_id;
                if(vm.$store.getters.reminder_search?.from_date_time){
                    vm.from_date_time = vm.changeDateMeta(vm.$store.getters.reminder_search?.from_date_time)
                    vm.to_date_time = vm.changeDateMeta(vm.$store.getters.reminder_search?.to_date_time)
                    vm.config.defaultDate = [vm.from_date_time, vm.to_date_time]
                }

            });
        },
        methods: {
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            getSelectedDates(dates){
				let vm = this;
				vm.from_date_time = moment(dates[0]).format("DD-MM-YYYY")
				vm.to_date_time = moment(dates[1]).format("DD-MM-YYYY")
			},
            changeDate(date_time) {
                return moment(date_time).format("DD-MM-YYYY hh:mm:ss A");
            },
            changeDateTime(date_time) {
                if (!date_time) {
                    return "";
                }
                const parsed = moment.tz(
                    date_time,
                    ["YYYY-MM-DD HH:mm:ss", moment.ISO_8601],
                    "Asia/Kolkata"
                );
                if (parsed.isValid()) {
                    return parsed.format("DD-MM-YYYY hh:mm:ss A");
                }
                return moment(date_time).tz("Asia/Kolkata").format("DD-MM-YYYY hh:mm:ss A");
            },
            changeDateTimeMeta(date_time) {
                return moment(date_time, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss");
            },
            changeDateMeta(date_time){
                return moment(date_time).format("DD-MM-YYYY HH:mm:ss");
            },
            index() {
                let vm = this;
                vm.meta.from_date_time = vm.changeDateTimeMeta(vm.from_date_time)
                vm.meta.to_date_time = vm.changeDateTimeMeta(vm.to_date_time)
                this.$store.commit("setReminderSearch", vm.meta)
                vm.$store.dispatch("post", { uri: "sessionComments/paginateUserCommentsReminders", data: vm.meta })
                .then(function (response) {
                    // vm.session_comments = []
                    vm.session_comments = response?.data?.data?.data;
                    vm.meta.totalRows = response?.data?.data?.meta?.total;
                    vm.meta.lastPage = response?.data?.data?.meta?.lastPage;
                    vm.meta.from = response?.data?.data?.meta?.from;
                    const end = vm.meta.from + Number(vm.meta.per_page) - 1;
                    vm.meta.to = end > vm.meta.totalRows ? vm.meta.totalRows : end;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(function (error) {
                    // console.log('errors:----', error)
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
            },
            getUsers() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", {
                        uri: "users/getUsers",
                        data: {
                            active_only: true,
                            attendance_type: "marketing",
                        },
                    })
                    .then((response) => {
                        loader.hide();
                        vm.users = response.data.data;
                        vm.index();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },

            getStages(){
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "stages/getStage" })
                    .then((response) => {
                        loader.hide();
                        vm.stages = response.data.data;
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            view(session_form) {
                this.$router.push("/session_forms/" + session_form.session_form_id + "/view");
            },

            onPageChange(page) {
                this.meta.page = page;
                this.index();
            },
            sort(field) {
                this.meta.keyword = field;
                this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
                this.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
            viewComment(session_comment) {
                console.log("session_comment", session_comment)
                this.session_comment = session_comment.comment;
            },
            openEditReminderDate(session_comment) {
                this.editReminder = session_comment;
                this.editReminderErrors = {};
                const current = session_comment?.reminder_date_time
                    ? moment(session_comment.reminder_date_time, ['YYYY-MM-DD HH:mm:ss', moment.ISO_8601], true)
                    : null;
                if (current?.isValid()) {
                    this.editReminderDateTime = current.format('DD-MM-YYYY HH:mm');
                } else {
                    this.editReminderDateTime = moment().format('DD-MM-YYYY HH:mm');
                }
            },
            submitReminderDate() {
                let vm = this;
                vm.editReminderErrors = {};
                if (!vm.isAdmin) {
                    vm.$store.dispatch("error", "Only Admin can update visiting date");
                    return;
                }
                if (!vm.editReminder?.session_comment_id || !vm.editReminderDateTime) {
                    vm.editReminderErrors.reminder_date_time = "Next visiting date is required";
                    return;
                }
                const selected = moment(
                    vm.editReminderDateTime,
                    ['DD-MM-YYYY HH:mm', 'DD-MM-YYYY hh:mm:ss', 'YYYY-MM-DD HH:mm:ss', moment.ISO_8601],
                    true
                );
                if (!selected.isValid()) {
                    vm.editReminderErrors.reminder_date_time = "Please select a valid next visiting date";
                    return;
                }
                if (selected.isBefore(moment().startOf('day'))) {
                    vm.editReminderErrors.reminder_date_time = "Next visiting date cannot be earlier than today";
                    return;
                }
                const minutes = selected.hours() * 60 + selected.minutes();
                if (minutes < (9 * 60 + 30) || minutes > (18 * 60 + 30)) {
                    vm.editReminderErrors.reminder_date_time =
                        "Next visiting time must be between 9:30 AM and 6:30 PM (IST)";
                    return;
                }
                const payload = {
                    session_comment_id: vm.editReminder.session_comment_id,
                    reminder_date_time: selected.format('YYYY-MM-DD HH:mm:ss'),
                };
                let loader = vm.$loading.show();
                vm.$store
                    .dispatch("post", { uri: "sessionComments/updateReminderDate", data: payload })
                    .then(() => {
                        loader.hide();
                        vm.$store.dispatch("success", "Next visiting date updated successfully");
                        const modalEl = document.getElementById('editReminderDate');
                        if (modalEl && window.bootstrap?.Modal) {
                            const modal = window.bootstrap.Modal.getInstance(modalEl) || new window.bootstrap.Modal(modalEl);
                            modal.hide();
                        } else if (modalEl) {
                            const closeBtn = modalEl.querySelector('[data-bs-dismiss="modal"]');
                            if (closeBtn) closeBtn.click();
                        }
                        vm.editReminder = null;
                        vm.editReminderDateTime = '';
                        vm.index();
                    })
                    .catch((error) => {
                        loader.hide();
                        const message = error?.response?.data?.message || "Unable to update visiting date";
                        vm.editReminderErrors.reminder_date_time = message;
                        vm.$store.dispatch("error", message);
                    });
            },
            reset_search() {
                this.meta.user_id = "";
                this.meta.from_date_time = moment().format("DD-MM-YYYY");
                this.meta.to_date_time = moment().add(1, 'days').format("DD-MM-YYYY");

                if (this.$refs.flatpickr) {
                    this.$refs.flatpickr.fp.setDate([this.meta.from_date_time, this.meta.to_date_time]);
                }

                this.search();
            },
            async downloadExcel() {
                try {
                    const response = await axios({
                        url: this.$store.getters.apiUrl + 'api/' + 'sessionComments/excelDownloadUserCommentsReminders', // Your Node.js server endpoint
                        method: 'POST',
                        responseType: 'blob', // Important to handle the file as a blob
                        headers: {
                            Authorization: "Bearer " + this.$store.getters.token, // Add the token from Vuex store
                        },
                        data: this.meta,
                    });

                    // Create a link element to download the file
                    const dateTime = moment().format('DD-MM-YYYY_HH-mm-ss');
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `reminder_report_${dateTime}.xlsx`); // Set the file name
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } catch (error) {
                    console.error('Error downloading the file', error);
                }
            }
        },
    };
</script>


<style scoped>
    /* .sticky-col {
        position: -webkit-sticky;
        position: sticky;
        background-color: #fff;
        z-index: 3;
        border-right: 1px solid #dee2e6;
    }

    .col-0 {
        left: 0;
        width: 50px;
    }

    .col-1 {
        left: 25px;
        width: 250px;
    }

    .col-2 {
        left: 147px;
        background-color: #fff;
        min-width: 450px;
    }

    .col-3 {
        left: calc(50px + 560px);
        width: 100px;
    }

    .table {
        table-layout: auto;
        width: 100%;
    }

    .table-responsive {
        overflow-x: auto;
    } */
    .sticky {
        position: sticky;
        left: 0;
        background-color: #fff; /* Optional: Adds a white background for better visibility */
        z-index: 1; /* Ensures the sticky columns stay above other columns */
    }

    /* Optional: Apply a background color for the header cells */
    .sticky-col {
        background-color: #f8f9fa; /* Light grey background */
    }

    /* Fix the sticky columns on scroll */
    .sticky-col.col-0 {
        left: 0;
        z-index: 2; /* Higher index for the first column */
    }

    /* .sticky-col.col-1 {
        left: 28px;
        z-index: 2;
    }

    .sticky-col.col-2 {
        left: 165px;
        z-index: 2;
        max-width: 521px;
    }

    .sticky-col.col-3 {
        left: 680px;
        z-index: 2;
    } */

    .sticky-col.col-1 {
        left: 26px;
        z-index: 2;
    }

    .sticky-col.col-2 {
        left: 119px;
        z-index: 2;
    }

    .sticky-col.col-3 {
        left: 368px;
        z-index: 2;
    }

    table th, table td {
        padding: 6px 10px;
        /* border: 1px solid #dee2e6;  */
    }
    .text-wrap {
        /* word-wrap: break-word; */
        /* word-break: break-word; */
        /* white-space: normal; */
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        /* overflow: hidden; */
        /* text-overflow: ellipsis; */
        width: 250px; /* Adjust width to fit your layout */
    }
</style>